export default __webpack_public_path__ + "static/media/Suzana Aragão_.1b5bbe12.png";